"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsMember = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var PermissionLevelDisplay_1 = require("./PermissionLevelDisplay");
var SetPermissionsMenu_1 = require("./SetPermissionsMenu");
var usePermissionDisplayMode_1 = require("./usePermissionDisplayMode");
var usePermissionObject_1 = require("./usePermissionObject");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
var MemberAvatarLink = function (_a) {
    var member = _a.member;
    return (React.createElement(react_1.Link, { href: member.profileUrl },
        React.createElement(react_1.Avatar, { icon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faUser }), name: member.username, src: member.avatarUrl })));
};
var MemberName = function (_a) {
    var member = _a.member;
    return React.createElement(react_1.Flex, { fontWeight: "600" }, member.username);
};
var PermissionsMember = function (_a) {
    var member = _a.member;
    var _b = (0, usePermissionObject_1.usePermissionObject)(), objectType = _b.objectType, objectId = _b.objectId;
    var useSetUserPermission = (0, usePermissionsModalContext_1.usePermissionsModalContext)().useSetUserPermission;
    var setUserPermission = useSetUserPermission(objectType, objectId);
    var _c = React.useState(member.permissions.effectivePermission), currentPermissionLevel = _c[0], setCurrentPermissionLevel = _c[1];
    React.useEffect(function () {
        setCurrentPermissionLevel(member.permissions.effectivePermission);
    }, [member.permissions.effectivePermission]);
    var onChange = React.useCallback(function (permissionLevel) {
        setUserPermission.mutate({
            userids: [member.user.userid],
            permissionLevel: permissionLevel,
        }, {
            onError: function () {
                setCurrentPermissionLevel(member.permissions.effectivePermission);
            },
        });
        setCurrentPermissionLevel(permissionLevel);
    }, [member.user.userid, setUserPermission]);
    var mode = (0, usePermissionDisplayMode_1.usePermissionDisplayMode)();
    return (React.createElement(react_1.Flex, { justify: "space-between" },
        React.createElement(react_1.Stack, { align: "center", direction: "row", spacing: 4, "data-userid": member.user.userid },
            React.createElement(MemberAvatarLink, { member: member.user }),
            React.createElement(MemberName, { member: member.user })),
        mode === 'edit' && (React.createElement(SetPermissionsMenu_1.SetPermissionsMenu, { permissionLevel: currentPermissionLevel, onChange: onChange, isLoading: setUserPermission.isLoading })),
        mode === 'view' && React.createElement(PermissionLevelDisplay_1.PermissionLevelDisplay, { permissionLevel: currentPermissionLevel })));
};
exports.PermissionsMember = PermissionsMember;
